import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { GigiInfoModal } from '@/shared/ui/gigiInfoModal'
import { useState } from 'react'
import { BalanceText } from '@/shared/ui/balanceText'
import { ClickAwayListener } from '@mui/material'

type GigiBalanceProps = {
  modalStyles?: React.CSSProperties
  textJustifyContent?: 'center' | 'flex-end'
  balance: number
  variant?: 'profile' | 'default' | 'friends'
}

export const GigiBalance = (props: GigiBalanceProps) => {
  const { classes } = useStyles()
  const { modalStyles, textJustifyContent, balance, variant = 'default' } = props
  const userLang = useUnit($userLanguage)
  const units = lang[userLang].pages.units
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClickAway = () => {
    setIsModalOpen(false)
  }

  if (variant === 'default')
    return (
      <ClickAwayListener onClickAway={handleClickAway}>
        <>
          <div style={{ position: 'fixed', zIndex: 100, left: '0%', width: '100%', ...modalStyles }}>
            <GigiInfoModal isOpen={isModalOpen} />
          </div>
          <div className={classes.balanceTextWrapper}>
            <div
              className={classes.gigiTextWrapper}
              style={{ justifyContent: textJustifyContent }}
              onClick={() => setIsModalOpen(!isModalOpen)}
            >
              <span>{units.gigi}</span>
              <Icon
                view="helpSign"
                width={16}
              />
            </div>
            <BalanceText
              balance={balance}
              view="gigi"
            />
          </div>
        </>
      </ClickAwayListener>
    )
  if (variant === 'profile')
    return (
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <div style={{ position: 'fixed', zIndex: 100, left: '0%', width: '100%', ...modalStyles }}>
            <GigiInfoModal isOpen={isModalOpen} />
          </div>
          <div className={classes.balanceTextWrapperProfile}>
            <BalanceText
              balance={balance}
              view="gigi"
              textSize="s"
              iconSize={22}
            />
            <div
              className={classes.gigiTextWrapperProfile}
              style={{ justifyContent: textJustifyContent }}
              onClick={() => setIsModalOpen(!isModalOpen)}
            >
              <Icon
                view="helpSign"
                width={20}
              />
            </div>
          </div>
        </div>
      </ClickAwayListener>
    )
  if (variant === 'friends')
    return (
      <BalanceText
        balance={balance}
        view="gigi"
        textSize="xs"
        iconSize={18}
        fontStyle={{ textWrap: 'nowrap' }}
      />
    )
}
